// web/src/wrappers/RequireMfa.tsx
import React, { useMemo } from 'react'
import { navigate, routes } from '@redwoodjs/router'
import { useAuth } from 'src/auth'
import { getNonEmptyStringArray } from 'src/utils/data-checkers-parsers'

const TwoFactorWrapper = ({ children }: { children: React.ReactNode }) => {
  const { currentUser, loading } = useAuth()

  const useTwoFactor =
    process.env.REDWOOD_ENV_ENABLE_MFA === 'true' ? true : false

  const roles = useMemo(
    () => getNonEmptyStringArray(currentUser?.roles),
    [currentUser]
  )

  const role = roles[0]

  if (
    !loading &&
    role === 'admin' &&
    currentUser?.twoFactorEnabled &&
    !currentUser?.twoFactorVerified &&
    useTwoFactor
  )
    navigate(routes.twoFactor())

  return <>{children}</>
}

export default TwoFactorWrapper
